<div class="bp-modal mod-lg wrapper">
  <bp-modal-header
    [title]="'send_via' | translate: [selectedCryptocoin?.name, selectedNetwork?.name]"
    class="font-semibold">
    <a (click)="onBackButtonClick()" (keydown.enter)="onBackButtonClick()" [tabIndex]="0" left>
      {{ "back" | translate }}
    </a>
    <a (click)="onCancelButtonClick()" (keydown.enter)="onCancelButtonClick()" [tabIndex]="0" right>
      {{ "cancel" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section">
      <div class="bp-modal-description">
        <div class="description-title">
          {{ "summary" | translate }}
        </div>
        <div class="info-title">
          {{ "multichain_withdrawal_summary_subtitle" | translate }}
        </div>
        @if (onBehalfOf) {
          <div class="info-title">
            {{ "asset_send_sending_on_behalf" | translate }}:
            <span class="color-black">{{ onBehalfOf }}</span>
          </div>
        }
        <div class="cards">
          <summary-grid
            (onStepClick)="clickedAssetCard()"
            class="summary-grid-item"
            titleKey="from_summary_send">
            <ng-container iconContainer>
              <div class="summary-card__currency-symbol">
                <img
                  #img
                  [src]="selectedCryptocoin.logo"
                  [style.width.px]="40"
                  alt="{{ 'logo_alt_text' | translate }}" />
              </div>
            </ng-container>
            <ng-container detailsContainer>
              <span class="summary-card__text wallet-name text-word-break">{{ wallet?.getName() }}</span>
              <br />
              <ng-container>
                @if (selectedNetwork?.name) {
                  <div class="via-text text-small-black">
                    <span class="color-neutral-new"> {{ "via" | translate }} </span>
                    <img class="network-img" [src]="selectedNetwork.logo" />
                    {{ "name_network" | translate: [selectedNetwork.name] }}
                  </div>
                }
              </ng-container>
            </ng-container>
          </summary-grid>
          <summary-grid
            (onStepClick)="clickedContactCard()"
            class="summary-grid-item"
            titleKey="to_summary_send">
            <ng-container detailsContainer>
              @if (isContact()) {
                <div class="monogram">
                  {{ monogram }}
                </div>
              }
              <div>
                @if (!isContact()) {
                  <div class="summary-card__external-symbol bpi__icon-send monogram"></div>
                  <div class="summary-card__contact-name margin-b-eight">{{
                    "external_wallet" | translate
                  }}</div>
                }
              </div>
              @if (isContact()) {
                <span class="summary-card__contact-name margin-b-eight">
                  {{ maskedContact }}
                </span>
              }
              <p class="text-small-black color-neutral-new margin-b-eight masked-addr">
                {{ maskedAddress }}
              </p>
              @if (shouldDisplayLEI) {
                <div class="text-small-black color-neutral-new margin-b-eight">
                  {{ legalEntityIdentifier }}
                </div>
              }
              @if (sendTransaction.getDestinationTag()?.length > 1) {
                <div
                  class="text-small-black color-neutral-new">
                  {{ sendTransaction.getDestinationTag() }}
                </div>
              }
              @if (
                selectedNetwork.destination_tag &&
                (!sendTransaction.getDestinationTag() ||
                !sendTransaction.getDestinationTag().length)
                ) {
                <div
                  (mouseleave)="trackingFacade.trackSummaryTooltipViewed()"
                  class="text-small-black color-neutral-new"
                  >
                  {{ "empty_memo" | translate }}
                  <span
									[bp-tooltip]="
										'missing_dest_tag_tooltip' | translate: [DTType | lowercase, DTType | lowercase]
									"
                  class="bpi__icon-attention"></span>
                </div>
              }
              <p class="text-small-black color-neutral-new margin-b-eight margin-t-eight">
                {{ selectedHost }}
              </p>
            </ng-container>
          </summary-grid>
          <summary-grid (onStepClick)="clickedAmountCard()" class="summary-grid-item" titleKey="amount">
            <ng-container detailsContainer>
              <div class="text-big-black">
                <strong>{{ totalCoin + " " + selectedCryptocoin.symbol | uppercase }}</strong>
              </div>
              <div class="text-small-black"
                >&asymp;&nbsp;{{
                +sendTransaction.getAmountFiat() + (+fee?.fiat_fee | euro_to_user_fiat)
                | fiat_precision_symbol
                : {
                id: fiat.getId(),
                currencies: [fiat],
                symbol: true,
                valueFirst: true
              }
              }}
            </div>
            @if (+fee?.fiat_fee !== 0) {
              <div class="text-small-black fees-inkl color-neutral-new">
                {{ "inkl" | translate }}
                {{
                +fee?.fiat_fee
                | euro_to_user_fiat
                | fiat_precision_symbol
                : {
                id: fiat?.getId(),
                prefix: +fee?.fiat_fee < 0.01,
                symbol: true,
                currencies: [fiat],
                valueFirst: true
              }
              }}
              {{ "fees" | translate | lowercase }}
            </div>
          }
          @if (+fee?.fiat_fee === 0) {
            <div class="text-small-black fees-inkl color-neutral-new">
              {{ "free" | translate | capitalize }}
            </div>
          }
        </ng-container>
      </summary-grid>
    </div>

    <div class="toggle-container">
      <bp-switch class="toggle" (valueChange)="onToggleClick($event)">
        <div left>
          <div class="font-size-13">
            {{ "withdrawal_multichain_toggle_info" | translate }}
          </div>
        </div>
      </bp-switch>
    </div>

    <button
      [disabled]="!termsAccepted"
      (click)="transfer()"
      class="btn btn-primary btn-lg mod-button-width button-next"
      type="button">
      {{ "transfer" | translate }}
    </button>
  </div>
</div>
</div>
</div>
